import {Heading16, Heading32, mobileOnly} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {GetSelfServiceFlowSectionResponse} from '../types';

interface SelfServiceFlowTitleViewProps {
  title: GetSelfServiceFlowSectionResponse['title'];
  small?: boolean;
}

export const SelfServiceFlowTitleView = ({
  title,
  small = false,
}: SelfServiceFlowTitleViewProps) => {
  const TitleComponent = small ? Heading16 : Heading32;
  return (
    <Margin>
      <TitleComponent as="h1">{title}</TitleComponent>
    </Margin>
  );
};

const Margin = styled.div`
  margin: 32px 0px;

  ${mobileOnly(
    css`
      margin: 20px 0px;
    `,
  )}
`;
